import { useUserContext } from '@vp/ubik-context';
import { useIsFeatureFlagActive } from '@99designs/experiments';
import { HolidayHubMainContent, HubMainContent } from '@99designs/feature-design-services-landing';
import { lowercaseLocaleToIso } from '@99designs/i18n';
import type {
    PopularProductsType as PopularProducts,
    ProductGroups,
} from '@99designs/feature-design-services-landing';

interface ContentProps {
    productGroups: ProductGroups;
    popularProducts?: PopularProducts;
}

export const Content = ({ productGroups, popularProducts }: ContentProps) => {
    const { locale, queryStrings } = useUserContext();
    const isHolidayFeatureEnabled = useIsFeatureFlagActive('design_services_holiday_hub');

    return isHolidayFeatureEnabled() ? (
        <HolidayHubMainContent
            locale={lowercaseLocaleToIso(locale)}
            selectedCategoryId={queryStrings?.['category']}
            productGroups={productGroups}
            popularProducts={popularProducts}
        />
    ) : (
        <HubMainContent
            locale={lowercaseLocaleToIso(locale)}
            selectedCategoryId={queryStrings?.['category']}
            productGroups={productGroups}
        />
    );
};
